import { render, staticRenderFns } from "./WholesaleTicket.vue?vue&type=template&id=6fafa42e&scoped=true&"
import script from "./WholesaleTicket.vue?vue&type=script&lang=js&"
export * from "./WholesaleTicket.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleTicket.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WholesaleTicket.vue?vue&type=style&index=1&id=6fafa42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fafa42e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VChip,VIcon,VMenu,VSimpleTable,VTooltip})
